export const REQUIRED_FIELD_MESSAGE = 'Это поле обязательно';
export const MIN_LENGTH_MESSAGE = 'Поле должно содержать минимум 2 символа';
export const MAX_LENGTH_MESSAGE = 'Поле должно содержать максимум 250 символов';
export const EMAIL_NOT_VALID_MESSAGE = 'Некорректный E-mail';
